import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ShieldUserIcon = createIcon({
  displayName: 'ShieldUserIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M0,0H24V24H0Z" fill="none" />
      <circle cx="12" cy="10.5" r="2.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path
        d="M20,12.52087c0,3.7747-4.64485,6.57877-6.85988,7.70461a2.50473,2.50473,0,0,1-2.27647.00195C8.65012,19.1027,4,16.29177,4,12.52087L4,7.06935a1.01225,1.01225,0,0,1,.9021-.99168,11.39249,11.39249,0,0,0,5.8725-2.17176,2.05249,2.05249,0,0,1,2.45076,0,11.39249,11.39249,0,0,0,5.8725,2.17176A1.01225,1.01225,0,0,1,20,7.06935Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16.90073,17.80146,16.441,16.882A2.5,2.5,0,0,0,14.20492,15.5H9.79508A2.5,2.5,0,0,0,7.559,16.882l-.45738.91476"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const ShieldUser: FC<IconProps> = (props) => {
  return <CustomIcon as={ShieldUserIcon} {...props} />
}

export default memo(ShieldUser)
